
import Vue from  'vue'
import {getBounds} from '../../utils/dom/pos.js'

export default {

    data()
    {
        return {

            offset: 0,
            isIn: true
        }
    },

    props: {

        margin: { type: Number, default: 150 },

        velocity: { type: Number, default: 1 },
        // onResized: { type: Function, default: null },

        // used for is in detection
        applyOffsetToY: { type: Boolean, default: false },

        // 0 -> window top, 1 -> window bottom
        yReference: { type: Number, default: 0.5 },

        scrollY: { type: Number, default: 0 },

        // Optional value object used to transit data from parent to child:
        // <parent> -> <core-drag-area> -> <child>
        data: Object
    },

    watch: {
        scrollY: '_scrollY'
    },

    created()
    {
        this._yTop = 0
        this._yBottom = 0
        this._yMedian = 0

        this._onResized = this._onResized.bind(this)

    	this.eventHub.$on('window:resized', this._onResized)
    },

    mounted()
    {
        this._onResized()
        this._scrollY(0)
    },

    destroyed()
    {
        this.eventHub.$off('window:resized', this._onResized)
    },

    methods: {

        _onResized()
        {
            // force visibility before check size
            const cacheVisibility = this.$el.style.visibility
            const cacheDisplay = this.$el.style.display

            this.$el.style.visibility = 'visible'
            this.$el.style.display = 'block'

            const bounds = getBounds(this.$el)
            this._yTop = bounds.y - this.margin
            this._yBottom = bounds.y + bounds.h + this.margin
            this._yMedian = bounds.y + bounds.h * 0.5

            this._scrollY(this._lastScroll)

            this.$el.style.visibility = cacheVisibility
            this.$el.style.display = cacheDisplay

            /*Vue.nextTick(function () {
                // DOM updated
            })*/
        },

        _resize()
        {
            this._onResized()
            this.$emit('resized')
        },

        _getOffset( scrollTop )
        {
            const yRef = this.yReference
            const scrollBottom = scrollTop + this.$root.$children[0].windowSize[1]
            const scrollMedian = (scrollTop * (1 - yRef) + scrollBottom * yRef)
            return (this._yMedian - scrollMedian) * this.velocity
        },

        _scrollY( scrollTop )
        {
            const scrollBottom = scrollTop + this.$root.$children[0].windowSize[1]
            const offset = this._getOffset(scrollTop)

            const appOffset = this.applyOffsetToY ? offset : 0
            const yTop = this._yTop + appOffset
            const yBot = this._yBottom + appOffset
            const yMed = this._yMedian + appOffset


            if( yTop < scrollBottom && yBot > scrollTop )
            {
                this.offset = offset.toFixed(2)

                if (!this.isIn)
                {
                    this.isIn = true
                    this.$emit('window-in')
                }
            }
            else if (this.isIn)
            {
                this.isIn = false
                this.$emit('window-out')
            }

            this._lastScroll = scrollTop
        },

        /*_onEnterFrame( dt )
        {

        }*/
    }

}
